export const youtubeUrltoEmbed = (url: string) => {
  const id = url.split("v=")[1];

  return `https://www.youtube.com/embed/${id}`;
};
